<template>
  <jade-box
    :title="$t('tpvByAcquirerTitle')"
    hasPadding
    class="flex-1"
  >
    <template #action>
      <div class="flex items-center gap-1">
        <jade-switch
          @onClick="toogleType"
          name="acquirersSwitch"
          disabledFocus
        />
        <jade-text>Valor em R$</jade-text>
      </div>
    </template>
    <template>
      <dash-card-content-fallback :hasData="hasData">
        <dash-progress-bar
          v-for="(item, index) in acquirers"
          :key="item.key + '' + index"
          :value="item.percentage"
          :color="item.color"
          :currency="item.value"
          :show-currency="dataType === dataTypeEnum.VALUE"
        >
          <acquirer-icons :data-icon="item.leftIcon" />

          <jade-text>{{ $t(item.name) }}</jade-text>

          <acquirer-icons
            :data-icon="item.rightIcon"
            :dataType="dataType"
          />
        </dash-progress-bar>
      </dash-card-content-fallback>
    </template>
  </jade-box>
</template>

<script>
import { JadeText, JadeSwitch, JadeBox } from '@jade'

import { DASHBOARD_DATA_TYPE_ENUM } from '@/enums/dash-progress-data-type.enum'
import MathManager from '@/utils/math-manager.utils'

import DashProgressManager from '../dash-progress.manager'

import DashCardContentFallback from '../components/DashCardContentFallback/index.vue'
import DashProgressBar from '../components/DashProgressBar/index.vue'

import AcquirerManager from './acquirer.manager'
import AcquirerIcons from './AcquirerTooltip.vue'

export default {
  name: 'Acquirers',

  components: {
    JadeBox,
    JadeSwitch,
    JadeText,

    DashProgressBar,
    DashCardContentFallback,

    AcquirerIcons
  },

  props: {
    data: Array
  },

  data () {
    return {
      dataTypeEnum: DASHBOARD_DATA_TYPE_ENUM,
      dataType: DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
    }
  },

  computed: {
    hasData () {
      return this.acquirers.length > 0
    },
    total () {
      return MathManager.sumByKeys(this.data)?.quantity ?? 0
    },
    acquirers () {
      return new AcquirerManager(
        new DashProgressManager(this.data, this.total)
      ).get()
    }
  },
  methods: {
    toogleType () {
      this.dataType =
        this.dataType === DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
          ? DASHBOARD_DATA_TYPE_ENUM.VALUE
          : DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "tpvByAcquirerTitle": "Adquirentes mais utilizadas",
      "tpvByAcquirerDescription": "Total do TPV capturado por cada adquirente."
    },
    "en-US": {
      "tpvByAcquirerTitle": "Most used acquirers",
      "tpvByAcquirerDescription": "Total TPV captured by each acquirer."
    }
  }
  </i18n>
